/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminService } from './services/admin.service';
import { FaqService } from './services/faq.service';
import { GalleryService } from './services/gallery.service';
import { InquiryService } from './services/inquiry.service';
import { NoticeService } from './services/notice.service';
import { NewsService } from './services/news.service';
import { SettingService } from './services/setting.service';
import { LogService } from './services/log.service';
import { PolicyService } from './services/policy.service';
import { PlaceService } from './services/place.service';
import { CompanyService } from './services/company.service';
import { EventService } from './services/event.service';
import { ExcelService } from './services/excel.service';
import { SponsorService } from './services/sponsor.service';
import { MarketingConsentService } from './services/marketing-consent.service';
import { PreRegistrationService } from './services/pre-registration.service';
import { BoothApplicationService } from './services/booth-application.service';
import { BoothOptionTemplateService } from './services/booth-option-template.service';
import { BroadcastScheduleService } from './services/broadcast-schedule.service';
import { HistoryService } from './services/history.service';
import { FloorPlanService } from './services/floor-plan.service';
import { PopupService } from './services/popup.service';
import { ExhibitorService } from './services/exhibitor.service';
import { HeroBannerService } from './services/hero-banner.service';
import { KioskConfigService } from './services/kiosk-config.service';
import { StorageService } from './services/storage.service';
import { AlimTalkLogService } from './services/alim-talk-log.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminService,
    FaqService,
    GalleryService,
    InquiryService,
    NoticeService,
    NewsService,
    SettingService,
    LogService,
    PolicyService,
    PlaceService,
    CompanyService,
    EventService,
    ExcelService,
    SponsorService,
    MarketingConsentService,
    PreRegistrationService,
    BoothApplicationService,
    BoothOptionTemplateService,
    BroadcastScheduleService,
    HistoryService,
    FloorPlanService,
    PopupService,
    ExhibitorService,
    HeroBannerService,
    KioskConfigService,
    StorageService,
    AlimTalkLogService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
